export default {
  orange: '#ff5f0e',
  white: '#ffffff',
}